import React, { Component, Fragment } from 'react';
import { EditorContainer, Word, TextArea} from './StyledComponents';

class Editor extends Component {
  constructor(props) {
    super(props)
    this.textAreaRef = React.createRef()
    this.divRef = React.createRef()
    this.state = {
      scrollTop: 0
    }
  }
  createLineNumber = number => {
    const length = number.toString().length
    const spacing = []
    for (var i = 4 - length; i > 0; i--) {
      spacing.push(<Word invisible>'</Word>)
    }

    return <Fragment>{spacing}<Word color='#666666'>{number}</Word><span> </span></Fragment>
  }
  componentDidUpdate = (prevProps) => {
    if (!this.textAreaRef || !this.divRef) {
      return
    }
    if (prevProps.editing !== this.props.editing) {
      if (this.props.editing) {
        this.textAreaRef.current.scrollTop = this.state.scrollTop
      } else {
        this.divRef.current.scrollTop = this.state.scrollTop
      }
    }
  }
  formatText = text => {

    let commenting = false;
    let comment = '';
    let space = false
    let lineNumber = 0;
    const formatted = text.map((word, i) => {
        if (word.includes('\"')) {
          word = word.replace('\\"', "'")
          word = word.replace('\\"', "'")
        }
      // if we are on a commented out line - collect the comment until we have a new line
      if (commenting) {
        if (word === '\\n') {
          commenting = false;
          const finalComment = comment;
          comment = '';
          lineNumber ++
          const style = this.props.wordList['// comments']
          return (
            <Fragment key={i}>
              <Word
                underline={style.u}
                italic={style.i}
                bold={style.b}
                color={style.c}
                background={style.bg}
                onClick={e => {
                  this.props.onClickWord("// comments");
                }}
              >{finalComment}</Word>
              <br />
              {this.createLineNumber(lineNumber)}
            </Fragment>
          );
        } else {
          comment += word;
        }
        return '';
      }
      // if its quotes, return a simplified quote (error in JSON parsing fix)
      if (word === `\\"`) {
        return '"';
      }
      // check for double spaces and create a double spaced word (for tab formatting)
      if (word === " ") {
        if (space) {
          space = false
          return <Word invisible>''</Word>
        }
        space = true
      }
      // if we are on new line - create new line with line number
      if (word === '\\n') {
        lineNumber++
        return <Fragment><br key={i} />{this.createLineNumber(lineNumber)}</Fragment>;

      } else if (word === '\\t') {
        // if its a tab - return a full tab character
        return <span key={i} style={{ opacity: 0 }}>''''</span>;
      } else if (word === '//') {
        // start of comments if this is the case
        commenting = true;
        comment += '//';
      } else if (/\\t|\\n|\\"|((http|https|ftp|ftps)\:\/\/[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,3}(\/[^" <>\\]*)?)|[^" \.,:;«»!?&<>(){}\-\+\[\]\\/]+|\/{1,}|[A-Za-z0-9а-яА-Я\u00c0-\u00ff]+|[^ \"]|./gim.test(word)) {
        const isString = word.split("'").length > 2 || word.split('"').length > 2
        if (isString) {
          const style = this.props.wordList["'strings'"]
          return <Word
                underline={style.u}
                italic={style.i}
                bold={style.b}
                color={style.c}
                background={style.bg}
                onClick={e => {
                  this.props.onClickWord("'strings'");
                }}

              >{word}</Word>
        }
        // we have a match - its a word, so print the word with the right parameters
        let style = this.props.wordList[word.toLowerCase()] || {};
        const note = this.props.notes[word.toLowerCase()];
        return (
          <Word
            key={i}
            id={`word-${i}`}
            underline={(this.props.noting && note) || style.u}
            italic={style.i}
            bold={style.b}
            background={style.bg}
            noteWord={this.props.noteWord.toLowerCase() === word.toLowerCase()}
            color={(style && style.c) || '#E3E3E3'}
            onClick={e => {
              this.props.onClickWord(word, e.pageX, e.pageY);
            }}
          >
            {word}
          </Word>
        );
      } else {
        // otherwise just return it as it is
        return word;
      }
      // catch anything else as an empty string
      return ''
    });
    formatted.unshift(this.createLineNumber(0))
    return formatted;
  };
  checkSidebar = () => {
    if (this.props.sidebar) {
      this.props.closeSidebar();
    }
  };
  checkTabs = e => {
    if (e.keyCode === 9) {
      // tab was pressed
      e.preventDefault();
      // get caret position/selection
      var val = e.target.value,
        start = e.target.selectionStart,
        end = e.target.selectionEnd;
      // set textarea value to: text before caret + tab + text after caret
      e.target.value = val.substring(0, start) + '\t' + val.substring(end);
      // put caret at right position again
      e.target.selectionStart = e.target.selectionEnd = start + 1;
      return false;
    }
  };
  saveScroll = (e) => {
      let element = e.target
      const { scrollTop } = element
      this.setState({ scrollTop })
  }
  render() {
    const { editing, placeholder, text } = this.props;
    return (
      <EditorContainer ref={this.divRef} editing={editing} onClick={() => this.checkSidebar()} onScroll={this.saveScroll}>
        {editing ? (
          <TextArea ref={this.textAreaRef} id="input-text" onKeyDown={this.checkTabs} onScroll={this.saveScroll}>
            {placeholder}
          </TextArea>
        ) : (
          this.formatText(text)
        )}
      </EditorContainer>
    );
  }
}

export default Editor;
